<template>
  <div class="project-horizontal-gallery" :style="{height: `${this.viewPort.height * 0.8}px`}">
    <!-- scrolling element -->
    <div class="scrolling-element" :style="{transform: galleryScroll}">
      <!-- single image -->
      <div
        v-for="galleryElement in galleryArray"
        :key="galleryElement.image.id"
        class="image"
        :style="{height: `${getImageHeight(galleryElement)}px`, width: `${getImageWidth(galleryElement)}px`}"
        >
        <ProjectImage
          width="100%"
          height="100%"
          style="white-space: initial;"
          full-width-caption
          eager
          :image="galleryElement"
          :author="author"
          :id="galleryElement.image.id"
          :openCaptionID.sync="openCaptionID"
          />
      </div>
    </div>
  </div>
</template>

<script>
import ProjectImage from '@/molecules/ProjectImage'
// import reverse from 'lodash/reverse'
import { Viewport } from '@monogrid/vue-lib'
import { RAF, ElasticNumber } from '@monogrid/js-utils'
import getAspect from '@/mixins/getAspect'

export default {
  name: 'ProjectHorizontalGallery',
  components: {
    ProjectImage
  },

  mixins: [Viewport, getAspect],

  created () {
    this.time = 0
    this.elasticImageX = new ElasticNumber(0)
    this.elasticImageX.speed = 5
    RAF.add(this.update)
  },
  beforeDestroy () {
    RAF.remove(this.update)
  },
  data () {
    return {
      openCaptionID: '',
      galleryScroll: 'translate3d(0, -50%, 0)',
      initial: true
    }
  },
  props: {
    gallery: {
      type: Array,
      required: true
    },
    author: {
      type: String,
      required: true
    },
    startScroll: {
      type: Number,
      required: true
    },
    chapterScroll: {
      type: Number,
      required: true
    },
    startDirection: {
      type: String,
      required: true
    },
    containerHeight: {
      type: Number,
      required: true
    }
  },

  // watch: {
  //   chapterScroll (value) {
  //     update
  //   }
  // },

  methods: {
    update () {
      const now = new Date().getTime()
      const delta = now - this.time
      // console.log(delta)
      let currentScroll
      if (this.startDirection === 'down') {
        currentScroll = this.startScroll - this.chapterScroll
      } else {
        currentScroll = (this.chapterScroll - this.startScroll)
      }

      let scrollRatio
      if (this.startDirection === 'down') {
        scrollRatio = Math.min(0, Math.max(-1, currentScroll / this.containerHeight))
      } else {
        scrollRatio = -1 - Math.min(0, Math.max(-1, currentScroll / this.containerHeight))
      }
      const totalScroll = this.scrollWidth// (this.viewPort.width) * (this.gallery.length)

      const scroll = totalScroll * scrollRatio

      // console.log(currentScroll, scrollRatio, this.startDirection)

      if (this.initial || this.$root.platform.mobile) {
        this.elasticImageX.value = scroll
        this.initial = false
      }

      this.elasticImageX.target = scroll

      this.elasticImageX.update(delta / 1000)
      // console.log(this.chapterScroll, this.elasticImageX.value)
      this.galleryScroll = `translate3d(${Math.round(this.elasticImageX.value * 10) / 10}px, -50%, 0)`
      this.time = now
    },
    getImageWidth (galleryElement) {
      const aspect = this.getAspect(galleryElement.image)
      const screenAspect = this.viewPort.width / this.viewPort.height

      if (aspect < screenAspect) return (this.viewPort.height * 0.8) * aspect

      return this.viewPort.width * 0.8
    },
    getImageHeight (galleryElement) {
      const aspect = this.getAspect(galleryElement.image)
      const screenAspect = this.viewPort.width / this.viewPort.height

      if (aspect < screenAspect) return this.viewPort.height * 0.8

      return (this.viewPort.width * 0.8) / aspect
    }
  },

  computed: {
    scrollWidth () {
      let cumulativeWidth = 0
      this.galleryArray.forEach(element => {
        const widthOnScreen = this.getImageWidth(element)
        cumulativeWidth += widthOnScreen
        cumulativeWidth += 100
      })
      return cumulativeWidth
    },
    galleryArray () {
      // if (this.startDirection === 'up') {
      //   return reverse(this.gallery.concat())
      // }
      return this.gallery
    }
  }
}
</script>

<style lang="scss" scoped>

.project-horizontal-gallery {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
}

.scrolling-element {
  will-change: transform;
  backface-visibility: hidden;
  position: relative;
  white-space: nowrap;
  // height: 100%;
  top: 50%;
}

.image {
  // background-color: #f00;
  // height: 50vh;
  margin-left: 30px;
  margin-right: 30px;
  display: inline-block;
  vertical-align: middle;
  // background-size: contain;
  // background-position: 50% 50%;
  // position: relative;
  // top: 50%;
  // transform: translateY(-50%);
}

</style>
